<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close" >
    <v-card>
      <v-card-title class="pt-4">Generate topographical profile</v-card-title>
      <v-card-text class="pl-4 pt-0">
        The current topographical profile will be replaced by an automatically generated topographical profile. <br><br>

        Are you sure you want to continue?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="create(currentItem.id)"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "TopoProfileGenerateDialog",
  data: () => ({}),
  computed: {
    ...mapState('topoProfile', {
      currentItem: state => state.currentItem,
    }),
    ...mapState('topoProfilePoint', {
      dialog: state => state.dialog,
      loading: state => state.generateLoading,
    }),
  },
  methods: {
    ...mapActions('topoProfilePoint', {
      toggleDialog: "toggleDialog",
      generate: "generate",

    },),
    close() {
      this.toggleDialog();
    },
    async create(id) {
      await this.generate(id);
      this.close()
    }
  },

}
</script>

